<script setup>
import { useLayout } from '@/layout/common/composables/layout';
import { cva } from 'class-variance-authority';
import { computed } from 'vue';
const props = defineProps({
    class: {
        type: String,
        default: ''
    }
});

const { layoutConfig, calculatedMenuMode, toggleAnchored, onClose } = useLayout();

const sidebarHeaderVariants = cva('relative flex items-center gap-3 p-4 [&_span]:whitespace-nowrap [&_span]:transition-all', {
    variants: {
        variant: {
            compact: 'w-9 h-16 !p-1.5 !pt-6 [&_span]:opacity-0 mx-auto',
            slim: 'w-9 h-16 !p-1.5 !pt-6 [&_span]:opacity-0 mx-auto',
            horizontal: '!py-0',
            drawer: 'h-16 !p-2.5 !py-4 group-data-[state=collapsed]/sidebar-wrapper:w-9 group-data-[state=collapsed]/sidebar-wrapper:[&_svg]:size-7 group-data-[state=collapsed]/sidebar-wrapper:[&_span]:opacity-0',
            reveal: 'w-full h-16 !p-2.5 !py-4  group-data-[state=collapsed]/sidebar-wrapper:[&_svg]:size-7 group-data-[state=collapsed]/sidebar-wrapper:[&_span]:opacity-0'
        }
    }
});

const sidebarHeaderClass = computed(() => {
    return sidebarHeaderVariants({
        variant: calculatedMenuMode.value,
        class: props.class
    });
});
</script>
<template>
    <div :class="sidebarHeaderClass">
        <slot />
        <button v-if="calculatedMenuMode === 'overlay'" @click="onClose" class="absolute right-6 top-1/2 -translate-y-1/2 w-6 h-6 rounded-md border hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-200">
            <i class="pi pi-times !text-xs" />
        </button>
        <button
            v-if="calculatedMenuMode === 'drawer' || calculatedMenuMode === 'reveal'"
            @click="toggleAnchored"
            class="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full border-2 border-surface-300 dark:border-surface-700 group-data-[state=collapsed]/sidebar-wrapper:opacity-0 group-data-[state=collapsed]/sidebar-wrapper:pointer-events-none transition-opacity group-data-[state=collapsed]/sidebar-wrapper:duration-0 duration-500 after:content-[''] after:absolute after:inset-0.5 after:rounded-full after:bg-surface-400 dark:after:bg-surface-600 after:transition-opacity after:duration-150"
            :class="layoutConfig.anchored ? 'after:opacity-100' : 'after:opacity-0 hover:after:opacity-50'"
        />
    </div>
</template>
